import { combineReducers } from 'redux';
import { createKeyedAsyncReducer } from '../../redux-util/async-helpers';
import { GET_TAXONOMIES } from '../bridge-methods';

const items = createKeyedAsyncReducer({
  actionKeys: GET_TAXONOMIES,
  param: 'id',
});

export default combineReducers({ items });
